import { Plus } from "lucide-react"; // Asigură-te că importul Plus există
import { useDropdowns } from "./UseDropdowns";
import type { Driver, DriverDropdownItem } from "@/types/drivers";
export const DriversDropdown: React.FC<DriverDropdownItem> = ({
  value,
  onChange,
  onAddNew,
  placeholder = "Selectează șoferul",
  required = false,
  className = "",
  showAddButton = true
}) => {
  const { data, loading, error, refetch } = useDropdowns();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
  const selectedId = e.target.value ? parseInt(e.target.value) : null;
  const selectedDriver = selectedId ? data.drivers.find(d => d.id === selectedId) : undefined;
  
  console.log('Drivers data:', data.drivers); // debug
  console.log('Selected driver:', selectedDriver); // debug
  
  onChange(selectedId, selectedDriver?.denumire, selectedDriver);
};

  if (loading) {
    return (
      <div className={`relative ${className}`}>
        <select disabled className="w-full px-4 py-3 border rounded-lg bg-gray-100">
          <option>Se încarcă șoferii...</option>
        </select>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`relative ${className}`}>
        <select disabled className="w-full px-4 py-3 border rounded-lg bg-red-50 border-red-200">
          <option>Eroare</option>
        </select>
        <button
          type="button"
          onClick={refetch}
          className="mt-1 text-sm text-red-600 underline"
        >
          Reîncearcă
        </button>
      </div>
    );
  }

  return (
    <div className={`relative ${className}`}>
      <div className="flex gap-2">
        <select
          value={value || ""}
          onChange={handleChange}
          required={required}
          className="flex-1 px-4 py-3 border rounded-lg bg-white focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
        >
          <option value="">{placeholder}</option>
          {data.drivers.map((driver: Driver) => (
              <option key={driver.id} value={driver.id}>
                {driver.denumire}
                {driver.telefon && ` (${driver.telefon})`}
              </option>
            ))}

        </select>
        
        {showAddButton && onAddNew && (
          <button
            type="button"
            onClick={onAddNew}
            className="px-3 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
            title="Adaugă șofer nou"
          >
            <Plus className="w-4 h-4" />
          </button>
        )}
      </div>
      
      {data.drivers.length === 0 && (
        <p className="text-sm text-gray-500 mt-1">Nu există șoferi în sistem</p>
      )}
    </div>
  );
};

export default DriversDropdown;